/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { size, toArray } from 'lodash';

import UploadItem from '../UploadItem';
import { filesAction } from 'src/redux/fileRedux';
import { View } from '..';
import './styles.scss';
// import PromptLeavingGuard from 'src/components/PromptLeavingGuard';

const UploadProgress = props => {
  const [isUploading, setIsUploading] = useState(false);
  const { fileProgress, uploadFiles } = props;
  const uploadedFileAmount = size(fileProgress);

  useEffect(() => {
    initBeforeUnLoad(toArray(fileProgress).length > 0);
  }, [fileProgress]);

  const initBeforeUnLoad = showExitPrompt => {
    window.onbeforeunload = event => {
      if (showExitPrompt) {
        const e = event || window.event;
        e.preventDefault();
        if (e) {
          e.returnValue = '';
        }
        return '';
      }
    };
  };
  useEffect(() => {
    const fileToUpload = toArray(fileProgress).filter(file => file.progress === 0);
    if (size(fileToUpload) > 0 && !isUploading) {
      setIsUploading(true);
      uploadFiles(fileToUpload);
    }
    if (size(fileToUpload) === 0) {
      setIsUploading(false);
    }
  }, [fileProgress]);

  // Some files still uploading. Please wait for all files to be uploaded before leaving this page
  return uploadedFileAmount > 0 ? (
    <View className={'cmp-upload-progress'}>
      {/* <PromptLeavingGuard isBlocking={true} title="Confirmation" message="Are you sure want to leave this page?" /> */}
      <h4 className={'mb-8'}>{`Uploading ${uploadedFileAmount} File(s)`}</h4>
      {size(fileProgress)
        ? toArray(fileProgress).map(file => <UploadItem key={`${file.id}-${file.depositionId}`} file={file} />)
        : null}
    </View>
  ) : null;
};

const mapStateToProps = state => ({
  fileProgress: state.file.fileProgress,
});

const mapDispatchToProps = {
  uploadFiles: filesAction.uploadFiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadProgress);
